module.exports = __webpack_public_path__ + "assets/img/activity_618_title1.d346bcb2.png";